// Clases del lienzo de barras para el esqueleto de la card, aquí porque una clase de
// `screens/` solo puede vivir en un módulo de pantalla (ds-lint cuenta los .js que la
// mencionan): el esqueleto las importa, no las repite.
export const ESQUELETO_BARRAS = {
    lienzo: "rev-cred-bars",
    barra: "rev-cred-bar",
    valor: "rev-num rev-cred-bar__value",
    dia: "rev-num rev-cred-bar__day",
};

const CreditsBars = ({ dias, formatInteger }) => {
    const max = dias.reduce((acc, d) => (d.value > acc ? d.value : acc), 0);
    const clase = dias.length > 14 ? "rev-cred-bars rev-cred-bars--dense" : "rev-cred-bars";

    return (
        <div className={clase}>
            {dias.map((d, idx) => {
                const h = Math.max(4, Math.round((d.value / Math.max(1, max)) * 100));
                return (
                    <div className="rev-cred-bar" key={`${d.label}-${idx}`}>
                        <span className={`rev-num rev-cred-bar__value${d.isMax ? ' rev-cred-bar__value--max' : ''}`}>
                            {d.value ? formatInteger(d.value) : '—'}
                        </span>
                        <svg
                            className="rev-cred-bar__svg"
                            viewBox="0 0 100 100"
                            preserveAspectRatio="none"
                            role="presentation"
                            aria-hidden="true">
                            <rect
                                x="0"
                                width="100"
                                y={100 - h}
                                height={h}
                                rx="4"
                                className={`rev-cred-bar__rect${d.isMax ? ' rev-cred-bar__rect--max' : ''}`} />
                        </svg>
                        <span className="rev-num rev-cred-bar__day">{d.label}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default CreditsBars;
